import React from 'react';

export default function HeadPhoneIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4 6.51999C10.62 6.82999 7 11.02 7 15.81V22.5C7 24.16 8.34 25.5 10 25.5H11C12.1 25.5 13 24.6 13 23.5V19.5C13 18.4 12.1 17.5 11 17.5H9V15.79C9 11.95 11.96 8.60999 15.79 8.49999C16.7268 8.47187 17.6597 8.63216 18.5333 8.97133C19.407 9.3105 20.2036 9.82166 20.8761 10.4745C21.5485 11.1273 22.083 11.9085 22.4478 12.7718C22.8126 13.6351 23.0004 14.5628 23 15.5V17.5H21C19.9 17.5 19 18.4 19 19.5V23.5C19 24.6 19.9 25.5 21 25.5H22C23.66 25.5 25 24.16 25 22.5V15.5C25 10.33 20.64 6.17999 15.4 6.51999Z"
        fill="#FECB04"
      />
    </svg>
  );
}
